import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  getCustomer
} from "../../utils/helpers";

import {
  notification
} from "../actions";

export const getCustomerSubscriptionById = createAsyncThunk("getCustomerSubscriptionById", async (payload, thunkAPI) => {
  let userId = getCustomer();
  try {
    let response = await axiosChargebee.get(`/v1/users/${userId}/subscription?subscription_id=${payload}`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return {}
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const updateSubscription = createAsyncThunk("updateSubscription", async (payload, thunkAPI) => {
  try {
    payload.subscriptionItems["replace_items_list"] = true;
    let response = await axiosChargebee.patch(`/v1/users/${payload.subscriptionId}/subscription`, payload.subscriptionItems);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({
        title: `Update Subscription`,
        message: `${response.data.message}`,
        type: `success`
      }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({
        title: `Update Subscription`,
        message: `${response.data.message}`,
        type: `warning`
      }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const pauseSubscription = createAsyncThunk("pauseSubscription", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.post(`/v1/subscriptions/pause?subscription_id=${payload}`);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({
        title: `Pause Subscription`,
        message: `${response.data.message}`,
        type: `success`
      }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({
        title: `Pause Subscription`,
        message: `${response.data.message}`,
        type: `warning`
      }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const cancelSchedulePause = createAsyncThunk("cancelSchedulePause", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.post(`/v1/subscriptions/cancel_pause_process?subscription_id=${payload}`);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({
        title: `Cancel Schedule Pause`,
        message: `${response.data.message}`,
        type: `success`
      }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({
        title: `Cancel Schedule Pause`,
        message: `${response.data.message}`,
        type: `warning`
      }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const cancelSubscription = createAsyncThunk("cancelSubscription", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.delete(`/v1/subscriptions?subscription_id=${payload}`);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({
        title: `Cancel subscription`,
        message: `${response.data.message}`,
        type: `success`
      }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({
        title: `Cancel subscription`,
        message: `${response.data.message}`,
        type: `warning`
      }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const updateSubscriptionTenant = createAsyncThunk("updateSubscriptionTenant", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.put(`/update-subscription`, payload);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const getCancelQuestions = createAsyncThunk("getCancelQuestions", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.get(`/questions?category=${payload}`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const saveCancelQuestions = createAsyncThunk("saveCancelQuestions", async (payload, thunkAPI) => {
  try {
    let response = await axiosTenant.post(`/questions`, payload);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({
        title: `Cancel Subscription Questions`,
        message: `${response.data.message}`,
        type: `success`
      }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({
        title: `Cancel Subscription Questions`,
        message: `${response.data.message}`,
        type: `warning`
      }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})